import { isSAMLWhitelistedURL } from '@nova/core';
import { LOGOUT_REDIRECT_URL_STORAGE_KEY } from '@satellite/plugins/util';

function getLogoutRedirectUrl() {
  const storedRedirectUrl = localStorage.getItem(LOGOUT_REDIRECT_URL_STORAGE_KEY);
  return storedRedirectUrl && isSAMLWhitelistedURL(storedRedirectUrl)
    ? storedRedirectUrl
    : '/login';
}

export async function logoutAndRedirect(logout: () => unknown) {
  const redirectUrl = getLogoutRedirectUrl();
  try {
    await logout();
  } finally {
    window.location.replace(redirectUrl);
  }
}
